import { forwardRef, useId } from 'react';
import { describedBy } from '../fieldMessages';
import { SelectProps } from './types';

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
    (
        {
            name,
            onChange,
            onBlur,
            autoFocus,
            autoComplete,
            label,
            value,
            error,
            errorMessage,
            classNames = '',
            children,
            testId,
            id,
            'aria-describedby': ariaDescribedBy,
            ...props
        }: SelectProps,
        ref
    ) => {
        const generatedId = useId();
        const selectId = id ?? generatedId;
        const errorId = `${selectId}-error`;
        return (
            <div className={`group relative w-full clear-both ${classNames ? classNames : 'mb-10'}`}>
                <label data-testid={testId} htmlFor={selectId} className="block text-sm">
                    {label}
                </label>
                <div className="flex justify-between">
                    <select
                        id={selectId}
                        autoFocus={autoFocus}
                        autoComplete={autoComplete}
                        name={name}
                        onChange={onChange}
                        onBlur={onBlur}
                        className={`w-full bg-transparent outline-hidden py-input-vert text-base`}
                        value={value}
                        ref={ref}
                        {...props}
                        aria-invalid={error ? true : undefined}
                        aria-describedby={describedBy(ariaDescribedBy, !!error && errorId)}
                    >
                        {children}
                    </select>
                </div>
                <div className={`${error !== undefined ? 'bg-warning' : 'bg-black group-hover:bg-primary group-focus-within:bg-primary'} input-border`} />
                {error && (
                    <p id={errorId} className="error-message">
                        {errorMessage}
                    </p>
                )}
            </div>
        );
    }
);
